
export const fetchPageMetaData = async (slug) => {
  try {
      const response = await fetch(`${process.env.REACT_APP_STRAPI_API_BASE_URL}/api/metas?filters[slug][$eq]=${slug}&populate[1]=metaImage`);
      
      if (!response.ok) {
          throw new Error("Failed to fetch page meta data");
      }

      const data = await response.json();
      
      // Check if data exists and return it, or handle empty result
      if (data?.data?.length > 0) {
          return data.data;
      } else {
          console.warn("No meta data found for the given slug");
          return null;
      }
  } catch (error) {
      console.error("Error fetching page meta data: ", error);
      return null;
  }
};